export default () => {
  const { protocol, hostname } = window.location
  const port = window.location.port ? `:${window.location.port}` : ''
  return `${protocol}//${hostname}${port}`
}



// WEBPACK FOOTER //
// ./src/utils/getHost.js